module.exports = __webpack_public_path__ + "img/free-logo-pc.ce6789ef.png";